import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import BusinessSelectionWizard from '../../Reusable/BusinessSelectionWizard';

// Shown right after registration (no auth token yet) so the professional can pick/add their business.
export default function StylistRegisterSelectBusiness() {
    const navigate = useNavigate();
    const location = useLocation();
    const registeredUser = location.state;

    // registration details are only ever reached via the Register button's navigate() call below;
    // a direct/refreshed visit has nothing to associate, so send them back to register
    if (!registeredUser) {
        navigate('/stylistregistration');
        return null;
    }

    const handleSaved = () => {
        Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Registration successful!',
            showConfirmButton: false,
            timer: 3000
        });
        setTimeout(() => {
            navigate('/thanks');
        }, 3000);
    };

    return (
        <BusinessSelectionWizard
            clientId={registeredUser.clientId}
            professionalFirstName={registeredUser.firstName}
            professionalLastName={registeredUser.lastName}
            professionalPhoneNumber={registeredUser.phoneNumber}
            onSaved={handleSaved}
        />
    );
}
